import { render, staticRenderFns } from "./Create2.vue?vue&type=template&id=79a38fee&"
import script from "./Create2.vue?vue&type=script&lang=js&"
export * from "./Create2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports